import { useState } from "react";
import { putPostRequest } from "../Axios/AxiosRequestConfiguration";
import putPostRequestInterface from "../Axios/putPostRequestInterface";

export interface putPostInterface {
  onSuccess: (data: any) => void;
  onError: (error: any) => void;
  method: string;
}
export const usePutPostAPI = (
  onSuccess: (data?: any, payload?: any) => void,
  onError: (error: any) => void,
  method: string
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [responseData, setResponseData] = useState<any>(null);

  const makeRequest = async (
    url: string,
    payload: any,
    onSuccessCallback?: () => void
  ) => {
    setLoading(true);
    putPostRequest({
      url: url,
      success: (data: any) => {
        setResponseData(data["data"]);
        onSuccess(data["data"], payload);
        if (onSuccessCallback) {
          onSuccessCallback();
        }
        setLoading(false);
      },
      failure: (err: any) => {
        setLoading(false);
        setError(err);
        onError(err);
      },
      body: payload,
      method: method,
    } as putPostRequestInterface);
  };

  return { makeRequest, loading, responseData, error };
};
